// extracted by mini-css-extract-plugin
export var actionButton = "_ad-1";
export var actionButtons = "_ad-2";
export var actions = "_ad-0";
export var aiUnread = "_ad-10";
export var alignCenter = "_ad-h";
export var backWrapper = "_ad-3";
export var cellContainer = "_ad-4";
export var checkboxContainer = "_ad-5";
export var contentContainer = "_ad-6";
export var contentHeader = "_ad-8";
export var conversationsTableWrapper = "_ad-s";
export var draftReplyBadgeContainer = "_ad-m";
export var dropdownItem = "_ad-b";
export var dropdownItemsContainer = "_ad-a";
export var dropdownTitle = "_ad-c";
export var errorIcon = "_ad-7";
export var filter = "_ad-d";
export var gray = "_ad-i";
export var headerActionButtons = "_ad-e";
export var headerCheckboxContainer = "_ad-f";
export var icon = "_ad-j";
export var menuContainer = "_ad-k";
export var noMoreTicketsIcon = "_ad-12";
export var noMoreTicketsSubText = "_ad-13";
export var oneLine = "_ad-l";
export var optionsButton = "_ad-n";
export var plus = "_ad-o";
export var portalButtonsWrapper = "_ad-g";
export var red = "_ad-p";
export var scrolledTop = "_ad-9";
export var search = "_ad-q";
export var selectedConversationsCount = "_ad-r";
export var spinner = "_ad-t";
export var strong = "_ad-u";
export var summaryCell = "_ad-v";
export var tableContainer = "_ad-11";
export var tagContainer = "_ad-w";
export var threeDots = "_ad-x";
export var twoLines = "_ad-y";
export var unread = "_ad-z";